import React from "react";
import Contactus from "../Components/contact/Contactus";
import PageHeader from "../Components/common/PageHeader";
import { useTranslation } from "react-i18next";
import SEO from "../Components/common/SEO";

function ContactusPage() {
  const { t } = useTranslation();
  const siteUrl = 'https://seymenkimya.com';
  const pageUrl = `${siteUrl}/bizeulasin`;

  const contactStructuredData = {
    '@context': 'https://schema.org',
    '@type': 'ContactPage',
    'name': 'Seymen Kimya İletişim',
    'url': pageUrl,
    'mainEntity': {
      '@type': 'LocalBusiness',
      'name': 'Seymen Kimya',
      'telephone': '+90-224-360-1166',
      'email': 'info@seymenkimya.com',
      'address': {
        '@type': 'PostalAddress',
        'addressCountry': 'TR',
        'addressLocality': 'Bursa'
      }
    }
  };

  return (
    <>
      <SEO
        title="Bize Ulaşın | Seymen Kimya"
        description="Seymen Kimya’ya hemen ulaşın. Ürün ve hizmetlerimiz hakkında bilgi alın."
        canonical={pageUrl}
        image={`${siteUrl}/assets/images/contact/contact.webp`}
        structuredData={contactStructuredData}
      />
      <PageHeader title={t("İLETİŞİM")} />
      <Contactus />
    </>
  );
}

export default ContactusPage;
